<template>
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>ステータス</label>
        <dropdown v-model="searchForm.model.status" @change="search()" :placeholder="'すべて'">
          <option value="">すべて</option>
          <option v-if="status.value !== 'none'" v-for="status in consts.MARUNAGE_SHOP_STATUS" :key="status.value" :value="status.value">{{ status.label }}</option>
        </dropdown>
      </div>
      <div class="six wide field">
        <label>問い合わせ番号 / 申込者名</label>
        <div class="ui action input">
          <input v-model="searchForm.model.q" type="text" placeholder="検索条件">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical top loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <pagination :pager="pager" :callback="search"></pagination>
    <table class="tableLayout">
      <thead>
        <tr>
          <th style="width: 10%" class="left aligned">お問合せ番号</th>
          <th style="width: 10%" class="left aligned">問い合わせ日時</th>
          <th style="width: 10%" class="center aligned">ステータス</th>
          <th style="width: 10%" class="center aligned">チャット</th>
          <th style="width: 10%" class="center aligned">お名前(カナ)</th>
          <th style="width: 10%" class="left aligned">希望日時</th>
          <th style="width: 10%" class="left aligned">人数</th>
          <th style="width: 10%" class="left aligned">一人当たりの予算</th>
          <th style="width: 20%" class="left aligned">希望条件など</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="banquet in banquets" :key="banquet.id" :class="{'finished': ['ng', 'closed', 'canceled'].includes(banquet.status)}">
          <td data-label="お問合せ番号">{{ banquet.marunage.code }}</td>
          <td data-label="問合せ日時">{{ banquet.created_at | formatDatetime }}</td>
          <td data-label="ステータス" class="center aligned">
            <div v-if="['ng', 'closed', 'canceled'].includes(banquet.status)">{{ banquet.status_label }}</div>
            <select v-else :value="banquet.status" @change="cancel($event, banquet)">
              <option :value="banquet.status" disabled>{{ banquet.status_label }}</option>
              <option value="canceled">成約せず</option>
            </select>
          </td>
          <td data-label="チャット" class="center aligned">
            <a :href="banquet.chat_url" target="_blank">
              <i v-if="banquet.chat && banquet.chat.unread_count > 0" class="green large talk icon"></i>
              <i v-else class="large comment icon"></i>
            </a>
          </td>
          <td data-label="お名前(カナ)" class="center aligned">{{ banquet.marunage.name_kana || banquet.marunage.name || '(未設定)' }}</td>
          <td data-label="希望日時">{{ banquet.marunage.event_date | formatDate }} {{ banquet.marunage.event_time }}</td>
          <td data-label="人数">{{ banquet.marunage.people_label }}</td>
          <td data-label="一人当たりの予算">{{ banquet.marunage.price_label }}</td>
          <td data-label="希望条件など"><div :title="banquet.marunage.note" class="ellipsis">{{ banquet.marunage.note | linebreakToSpace }}</div></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>

export default {
    data: function() {
        return {
            searchForm: this.createForm(this.query()),
            pager: this.createPager(15, this.query().offset),
            banquets: [],
        };
    },
    created: function() {
        this.search(this.pager.current());
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            this.replaceStateQuery(this.searchForm.model, ['limit']);
            return this.searchForm.get('/shopadmin/api/banquets', function(response) {
                this.banquets = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        },
        cancel: function(event, banquet) {
            if (!confirm('お問合せをキャンセルします。よろしいですか？')) {
                // FIXME: ステータスの変更を取りやめた際に、ドロップダウンの選択状態だけが変更後のステータスになったままになってしまう
                //        元のステータスに戻す良い方法が知りたい
                event.preventDefault();
                const status = banquet.status;
                banquet.status = '';
                banquet.status = status;
                return;
            }

            this.createForm({
                status: 'canceled'
            }).put('/shopadmin/api/banquets/' + banquet.id, function(response) {
                banquet.status = response.data.status;
                banquet.status_label = response.data.status_label;
                alert('キャンセルしました');
            }, function() {
                alert('キャンセルに失敗しました');
            });
        }
    }
};
</script>
